import moment from 'moment'

export const formatDateWithoutSeparator = (moment) =>
    moment.toLocaleDateString('en-GB').replace(/\//g, '')

/**
 * @param {string} date
 * @param {string} dateFormat
 * @param {string} inputFormat
 * @returns {string} Date/Time according to dateFormat param. DD.MM.YY [kl] HH:mm is default
 */
export function formatDate(date, dateFormat, inputFormat = '') {
    return moment(date, inputFormat ? inputFormat : null).format(
        dateFormat ? dateFormat : 'DD.MM.YY [kl] HH:mm'
    )
}
